import CarouselCard from 'home/components/CarouselCard/CarouselCard'
import { showUserReviewsRating } from 'lib/order/reviewUtils'
import React, { useContext } from 'react'
import LEOfferPriceDetailsWrapper from './LEOfferPriceDetailsWrapper'
import GeoContext from 'contexts/geoContext'
import FrontPageTileFlightPricing from 'components/OfferList/OfferListTiles/Support/FrontPageTileFlightPricing'
import offerPageURL from 'lib/offer/offerPageURL'
import OfferUrgencyLabels from 'components/Common/Labels/OfferUrgencyLabels'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'
import { connect } from 'react-redux'

interface Props {
  offer: App.Offer | App.OfferSummary
  onClick: () => void
  hasPassedWall: boolean
}

function LEOfferCard({ offer, onClick, hasPassedWall }: Props) {
  const { currentRegionHasFlights } = useContext(GeoContext)
  const rating = offer.property?.rating
  const reviewsTotal = offer.property?.reviewsTotal
  const ratingSubtitle = offer.property?.reviewsSource === 'google' ? 'From online reviews' : undefined
  const showFlightPricingDetails = currentRegionHasFlights && offer.offerFlightsEnabled && !offer.bundledWithFlightsOnly && (hasPassedWall || !offer.walledGarden)
  const showReviews = !!(offer.property?.rating && showUserReviewsRating(offer.property.rating, offer.property?.reviewsTotal))
  const reviews = {
    showReviews,
    rating,
    reviewsTotal,
    ratingSubtitle,
  }

  return (
    <CarouselCard
      bookmarkButton={<BookmarkButton offer={offer} />}
      description={offer.name}
      flightPricingDetails={showFlightPricingDetails ? <FrontPageTileFlightPricing offer={offer} /> : undefined}
      image={offer.image}
      location={[offer.locationHeading, offer.locationSubheading].filter((t) => t).join(', ')}
      title={offer.property?.name ?? ''}
      offerPriceDetails={<LEOfferPriceDetailsWrapper offer={offer} />}
      offerUrl={offerPageURL(offer)}
      productType={offer.productType}
      reviews={reviews}
      urgencyLabels={<OfferUrgencyLabels offer={offer} />}
      onClick={onClick}
    />
  )
}

const mapStateToProps = (state: App.State) => ({
  hasPassedWall: hasPassedWalledGarden(state),
})

export default connect(mapStateToProps)(LEOfferCard)
